module.exports = __webpack_public_path__ + "img/carousel-back--green.fe303ef9.svg";